import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import VuexPersistence from "vuex-persist";

import openings from "./modules/openings";
import search from "./modules/search";
import teams from "./modules/teams";
import language from "./modules/language";

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  key: "ebanx_careers",
  storage: window.sessionStorage
});

const storePlugins = localStorage && sessionStorage ? [vuexLocal.plugin] : [];

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",

  plugins: storePlugins,

  state: {
    instagramFeed: null
  },

  mutations: {
    setInstagramFeed(state, payload) {
      state.instagramFeed = payload;
    }
  },

  actions: {
    fetchInstagramFeed({ commit }) {
      axios
        .get(
          "https://api.instagram.com/v1/users/self/media/recent/?access_token=2349248451.1677ed0.9b4c55a0b9c84cdcace1f1cc9b213f61&callback=?&limit=1&count=5"
        )
        .then(resp => {
          commit("setInstagramFeed", resp.data.data);
        });
    }
  },

  getters: {
    instagramFeed(state) {
      return state.instagramFeed;
    }
  },

  modules: {
    openings,
    search,
    teams,
    language
  }
});
